import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {Card} from "@irati/ui/src/Layout/index"
import {warning, greys} from "@irati/ui/src/global/colors"

/**
 * Styled components
 */
const WarningCard = styled(Card)`
  background-color: ${warning.default};
  padding: 12px;
  margin: 20px 0;
  color: ${greys.dark};
  box-shadow: 0 0 0 1px ${warning.default};
`

const Warning = ({children}) => {
  return <WarningCard>{children}</WarningCard>
}

Warning.propTypes = {
  children: PropTypes.node
}

Warning.defaultProps = {
  children: null
}

export default Warning
